import { all, call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { AxiosCall } from "../../../utils/axios";
import * as actions from "./stageActions";

// ==================== STAGES OVERVIEW ====================

function* fetchStagesOverview(action) {
    try {
        const filters = action.payload || {};
        const queryParams = new URLSearchParams();

        // Add filters
        Object.keys(filters).forEach(key => {
            const value = filters[key];
            if (value === '' || value === null || value === undefined) {
                return;
            }
            if (key === 'organization' && String(value).toLowerCase() === 'all') {
                return;
            }
            queryParams.append(key, value);
        });

        const queryString = queryParams.toString();
        const url = `/mycore/stage/overview/${queryString ? `?${queryString}` : ''}`;

        const result = yield call(AxiosCall, url);
        yield put(actions.fetchStagesOverviewSuccess(result.data));
    } catch (e) {
        yield put(actions.fetchStagesOverviewFailure(e.message));
    }
}

// ==================== BATCH STAGES ====================

function* fetchBatchStages(action) {
    try {
        const { batchId } = action.payload;
        const result = yield call(AxiosCall, `/mycore/${batchId}/stage/by-batch/`);
        yield put(actions.fetchBatchStagesSuccess({ batchId, stages: result.data }));
    } catch (e) {
        yield put(actions.fetchBatchStagesFailure(e.message));
    }
}

// ==================== STAGE ACTIONS ====================

function* completeStage(action) {
    try {
        const { stageId, endDate } = action.payload;
        const payload = endDate ? { end_date: endDate } : {};
        const result = yield call(AxiosCall, `/mycore/${stageId}/stage/complete/`, 'POST', payload);
        yield put(actions.completeStageSuccess(result.data));
        // Refresh the overview
        yield put(actions.fetchStagesOverviewRequest());
    } catch (e) {
        yield put(actions.completeStageFailure(e.message));
    }
}

function* addStageNote(action) {
    try {
        const { stageId, note, append } = action.payload;
        const payload = { note, append };
        const result = yield call(AxiosCall, `/mycore/${stageId}/stage/add-note/`, 'POST', payload);
        yield put(actions.addStageNoteSuccess(result.data));
        // Refresh the overview
        yield put(actions.fetchStagesOverviewRequest());
    } catch (e) {
        yield put(actions.addStageNoteFailure(e.message));
    }
}

function* updateStage(action) {
    try {
        const { stageId, stageData } = action.payload;
        const result = yield call(AxiosCall, `/mycore/${stageId}/stage/update/`, 'PATCH', stageData);
        yield put(actions.updateStageSuccess(result.data));
        // Refresh the overview
        yield put(actions.fetchStagesOverviewRequest());
    } catch (e) {
        yield put(actions.updateStageFailure(e.message));
    }
}

// ==================== WATCHERS ====================

function* watchFetchStagesOverview() {
    yield takeLatest(actions.FETCH_STAGES_OVERVIEW.REQUEST, fetchStagesOverview);
}

function* watchFetchBatchStages() {
    yield takeEvery(actions.FETCH_BATCH_STAGES.REQUEST, fetchBatchStages);
}

function* watchCompleteStage() {
    yield takeEvery(actions.COMPLETE_STAGE.REQUEST, completeStage);
}

function* watchAddStageNote() {
    yield takeEvery(actions.ADD_STAGE_NOTE.REQUEST, addStageNote);
}

function* watchUpdateStage() {
    yield takeEvery(actions.UPDATE_STAGE.REQUEST, updateStage);
}

// ==================== ROOT SAGA ====================

export default function* stagesSaga() {
    yield all([
        watchFetchStagesOverview(),
        watchFetchBatchStages(),
        watchCompleteStage(),
        watchAddStageNote(),
        watchUpdateStage(),
    ]);
}
